import { ready } from '~/core'
import media from '~/utils/media'

ready('infoCards', '.infoCards-card', (infoCardsCard) => {
  const wrapper = infoCardsCard.closest('.infoCards')
  const open = infoCardsCard.querySelector('.infoCards-cardHeading')
  const close = infoCardsCard.querySelector('.infoCards-cardClose')

  open.addEventListener('click', () => {
    if (!media.lg.matches) {
      infoCardsCard.classList.toggle('is-open')
      wrapper.classList.toggle('is-active')
    }
  })

  close.addEventListener('click', () => {
    if (!media.lg.matches) {
      infoCardsCard.classList.remove('is-open')
      wrapper.classList.remove('is-active')
    }
  })

  //reset all menu classes, styles, and variables to default state;
  const reset = () => {
    wrapper.classList.remove('is-active')
    infoCardsCard.classList.remove('is-open')
  }

  // reset menu when we hit the desktop size
  media.lg.addListener((e) => {
    if (e.matches) {
      reset()
    }
  })
})
